import {DeleteProfileRequest} from "../../compiled";
import './AccountSettings.css'
import {ActionButton} from "../../util/UI/ActionButton";
import {useConfigurePaymentMethods} from "../../util/RpcHooks/ConfigurePaymentMethods";
import {useAuthUtil} from "../../util/AuthUtil";
import {isProduction} from "../../util/HostUtil";
import {useDebugDeleteUserRpc} from "../../util/RpcHooks/DebugDeleteUser";
import {AccountSettingsProfileBox} from "./AccountSettingsProfileBox";

export const AccountSettings = () => {

  const configurePaymentMethodsRpc = useConfigurePaymentMethods()
  const debugDeleteUserRpc = useDebugDeleteUserRpc();

  const {auth0Logout} = useAuthUtil();

  const deleteProfile = (nukeAccount: boolean) => {
    debugDeleteUserRpc.send(new DeleteProfileRequest({
      nukeAccount: nukeAccount
    }))
  }

  return <div className={'AccountSettingsPage'}>

    <AccountSettingsProfileBox/>
    
    <div className={'AccountSettingsBox'}>
      <div className={'AccountSettingsHeader'}>BILLING</div>
      <div><ActionButton secondary smaller onClick={configurePaymentMethodsRpc.send}>Payment methods</ActionButton>
      </div>
      <div className={'InputHelpText'}>This link will redirect you to stripe to configure your saved payment methods.
      </div>
    </div>

    {!isProduction() && <div className={'AccountSettingsBox'}>
      <div className={'AccountSettingsHeader'}>DEBUG STUFF</div>
      <div style={{display: 'flex', gap: 20}}>
        <ActionButton secondary onClick={auth0Logout}>log out</ActionButton>
        {/*<ActionButton secondary onClick={() => deleteProfile(false)}>reset profile (goes to survey)</button>*/}
        <ActionButton secondary onClick={() => deleteProfile(true)}>delete account</ActionButton>
      </div>
      {debugDeleteUserRpc.rpcState.state == 'error' && <div className={'ErrorText'}>Error deleting your profile.</div>}
    </div>}

  </div>

}